module.exports = __webpack_public_path__ + "static/media/falcontorch-2.ebb5e788.jpg";